export const METHOD_KIND = {
  MK_UNKNOWN: 'MK_UNKNOWN',
  MK_MOBILE_MONEY: 'MK_MOBILE_MONEY',
  MK_BANK_TRANSFER: 'MK_BANK_TRANSFER',
  MK_LOCAL_METHOD: 'MK_LOCAL_METHOD',
  MK_CRYPTO: 'MK_CRYPTO',
} as const
